<template>
  <button
    v-if="!$screen.lg"
    class="hamburger hamburger--collapse"
    :class="{ 'is-active': isMobileOverlayOpen }"
    type="button"
    @click.prevent="toggleMobileOverlay"
  >
    <span class="hamburger-box">
      <span class="hamburger-inner"></span>
    </span>
  </button>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Burger',
  computed: mapState('pageHeader', ['isMobileOverlayOpen']),
  methods: mapActions('pageHeader', ['toggleMobileOverlay']),
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.hamburger {
  margin-right: utils.f-rem-calc(10);
}
</style>
